import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { OfferTypeContainer } from '../../containers/filters/OfferTypeContainer';
import { IFilter } from '../../types/filters';

export const offerType: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: OfferTypeContainer,
};
